import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: '[counter]',
  template: `
    <div class="input-group">
      <span class="input-group-btn">
        <button type="button" class="btn btn-default"
          (click)="decrement()"
          [disabled]="_value <= _min">
          <i class="fa fa-minus"></i>
        </button>
      </span>
      <input type="text" class="form-control text-center"
        [value]="_value"
        [readonly]="!_editable"
        (change)="onInputChange($event)">
      <span class="input-group-btn">
        <button type="button" class="btn btn-default"
          (click)="increment()">
          <i class="fa fa-plus"></i>
        </button>
      </span>
    </div>
  `
})
export class CounterComponent implements OnInit {
  @Input() value    : any;
  @Input() min      : number = 0;
  @Input() step     : number = 1;
  @Input() editable : string | boolean;

  @Output() valueChange: EventEmitter<number> = new EventEmitter();

  _value    = 0;
  _min      = 0;
  _editable = false;

  ngOnInit () : void {
    this._value    = parseInt(this.value, 10) || 0;
    this._min      = parseInt(String(this.min), 10) || 0;
    this._editable = this.editable === '' || !!this.editable;
  }

  increment () : void {
    this._value += parseInt(String(this.step), 10) || 1;
    this.valueChange.emit(this._value);
  }

  decrement () : void {
    const step     = parseInt(String(this.step), 10) || 1;
    const newValue = this._value - step;

    if (newValue >= this._min) {
      this._value = newValue;
      this.valueChange.emit(this._value);
    }
  }

  onInputChange ( event: Event ) : void {
    const input = event.target as HTMLInputElement;
    const val   = parseInt(input.value, 10);

    if (!isNaN(val) && val >= this._min) {
      this._value = val;
      this.valueChange.emit(this._value);
    }
  }
}
